import { ModuleWithProviders } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard, PrivilegeGuard, RouteRefreshComponent } from './shared';

const appRoutes: Routes = [
  {
    path: 'auth',
    loadChildren: './auth/auth.module#AuthModule'
  },
  {
    path: 'indiv-client',
    loadChildren: './indiv-client/indiv-client.module#IndivClientModule'
  },
  {
    path: 'caregivers',
    loadChildren: './caregivers/caregivers.module#CaregiversModule',
    canLoad: [AuthGuard]
  },
  {
    path: 'users',
    loadChildren: './users/users.module#UsersModule',
    canLoad: [AuthGuard],
    canActivate: [PrivilegeGuard]
  },
  {
    path: 'settings',
    loadChildren: './settings/settings.module#SettingsModule',
    canLoad: [AuthGuard],
    canActivate: [PrivilegeGuard]
  },
  {
    path: 'my-dashboard',
    loadChildren: './my-dashboard/my-dashboard.module#MyDashboardModule',
    canLoad: [AuthGuard],
    canActivate: [PrivilegeGuard]
  },
  {
     path: 'beacons',
     loadChildren: './beacons/beacons.module#BeaconsModule',
     canLoad: [AuthGuard],
     canActivate: [PrivilegeGuard]
  },
  {
    path: 'projects',
    loadChildren: './projects/projects.module#ProjectsModule',
    canLoad: [AuthGuard],
    canActivate: [PrivilegeGuard]
  },
  {
     path: 'help',
     loadChildren: './help/help.module#HelpModule',
  },
  {
    path: 'start',
    loadChildren: './start/start.module#StartModule',
  },
  {
    path: 'technical-support',
    loadChildren: './technical-support/technical-support.module#TechnicalSupportModule',
    canLoad: [AuthGuard],
    canActivate: [PrivilegeGuard]
  },
  {
    path: 'user-history',
    loadChildren: './user-history/user-history.module#UserHistoryModule',
    canLoad: [AuthGuard],
    canActivate: [PrivilegeGuard]
  },
  {
    path: 'call-manage',
    loadChildren: './call-manage/call-manage.module#CallManageModule',
    canLoad: [AuthGuard],
    canActivate: [PrivilegeGuard]
  },
  {
    path: '',
    component: RouteRefreshComponent,
    pathMatch: 'full'
  }
];

export const AppRoutingModule: ModuleWithProviders = RouterModule.forRoot(appRoutes);



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts